import React, { useState, useEffect, useRef } from 'react';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { GoChevronDown } from 'react-icons/go'

import { Box, Text, Flex, Avatar, useOutsideClick, useToast, Grid } from "@chakra-ui/react";
import { getThisUserIdToken, triggerLaunchdeckToast, validateEmail } from '../../global/helpers/global-helpers';
import { editDsrTeamMembers, resetEditDsrTeamMembers } from '../actions/dsr-actions';
import { checkIfExistingUser, resetCheckIfExistingUser } from '../actions/manage-dsr-member-actions';
import PageLoader from '../../global/components/helper-components/components/PageLoader';
import LaunchdeckButton from '../../global/components/helper-components/components/LaunchdeckButton';
import { determineIsNonCustomerUserAccount } from '../../profile/helpers/user-helper';
import { displayUserTeamRolePermissions } from '../helpers/dsr-helpers';
import LaunchdeckFormInput from '../../forms/TextInputField/components/LaunchdeckFormInput';
import { BsPersonVcard } from 'react-icons/bs';
import LaunchdeckTag from '../../global/components/helper-components/components/LaunchdeckTag';
import WarningTextMessage from '../../global/components/helper-components/components/WarningTextMessage';
import { IoPersonCircleOutline } from 'react-icons/io5';

function DsrAddTeamMemberForm({ 
  dsrId, 
  handleCloseModal, 
  // Redux
  isDsrAdmin,
  editDsrTeamMembersOutcome, 
  editingTeamInProgress, // TODO: Refactor since there will result in state flicker
  dsrUserTeam,
  checkIfExistingUserOutcome,
  isMobileView,
  // Actions
  editDsrTeamMembers,
  resetEditDsrTeamMembers,
  checkIfExistingUser,
  resetCheckIfExistingUser
}) {

  const toast = useToast();

  // Local States
  const [memberCardLocalState, setMemberCardLocalState] = useState({
    nextActionPath: ""
  })

  // Inputs
  const [emailInput, setEmailInput] = useState("")

  const [firstNameInput, setFirstNameInput] = useState("")
  const [lastNameInput, setLastNameInput] = useState("")
  const [companyNameInput, setCompanyNameInput] = useState("")
  const [titleInput, setTitleInput] = useState("")
  const [detectedExistingUserIdToken, setDetectedExistingUserIdToken] = useState("")

  const [teamNameInputDisplay, setTeamNameInputDisplay] = useState("")
  // const [updatedTeamStatus, setUpdatedTeamStatus] = useState(null)

  // Validation
  const [showIncompleteFormError, setShowIncompleteFormError] = useState(null)
  const [showNoTeamRoleError, setShowNoTeamRoleError] = useState(null)
  const [showNotValidEmailError, setShowNotValidEmailError] = useState(null)
  const [allInputsValidated, setAllInputsValidated] = useState(null)

  // UX management
  const [teamInput, setTeamInput] = useState("")
  const [showPickTeamDropdown, setShowPickTeamDropdown] = useState(false)
  const [buttonType, setbuttonType] = useState('proceed') // Possible values: 'proceed' & 'start-invite'

  const [showMemberCard, setShowMemberCard] = useState(false)
  const [showCustomiseInviteSection, setShowCustomiseInviteSection] = useState(false)
  const [isDuplicateUser, setIsDuplicateUser] =useState(false)

  const [isSearchingForUser, setIsSearchingForUser] = useState(false)

  const [chosenRole, setChosenRole] = useState("") // Possible Values: "" / "Member" / "Admin"
  const [showPickRoleDropdown, setShowPickRoleDropdown] = useState(false)
  const [isNoOrgUser, setIsNoOrgUser] = useState("")

  const initRef = useRef(null);
  const teamPickerDropdownRef = useRef(null);
  const rolePickerDropdownRef = useRef(null);

  useOutsideClick({
    ref: teamPickerDropdownRef,
    handler: () => setShowPickTeamDropdown(false),
  })

  useOutsideClick({
    ref: rolePickerDropdownRef,
    handler: () => setShowPickRoleDropdown(false),
  })

  useEffect(() => {
    // Business Logic: If user is in Audience/Buyer team, they can only invite other users to the Audience / Buyer team
    // There will be no inputs to determine which team to add for Audience
    // This is required to pass validation checks 
    if (!initRef.current) {
      const isNoOrgUser = determineIsNonCustomerUserAccount()
      setIsNoOrgUser(isNoOrgUser)
    }
    initRef.current = true

  }, []);



  useEffect(() => {
    // Business Logic: If user is in Audience/Buyer team, they can only invite other users to the Audience / Buyer team
    // There will be no inputs to determine which team to add for Audience
    // This is required to pass validation checks 
    if (dsrUserTeam === 'audience') {
      setTeamInput('buyer-team')
      setChosenRole("Member")
    }

  }, [dsrUserTeam]);

  useEffect(() => {
    // Business Logic: Validate & allow user to click on Add user button
    if ((emailInput && teamInput === "seller-team" && chosenRole) || (emailInput && teamInput === "buyer-team")) {
      setAllInputsValidated(true)

    } else {
      setAllInputsValidated(false)
      setbuttonType('proceed')
    }
  }, [emailInput, teamInput, chosenRole]);


  useEffect(() => {
    if (editDsrTeamMembersOutcome) {
      const { updatedTeamMembers } = editDsrTeamMembersOutcome || {}

      if (updatedTeamMembers) {
        toast(
          triggerLaunchdeckToast({
            useCase: "show-success-state",
            label: "Invitation successfully sent. Go right ahead & invite another!",
            isMobileView
          })
        )

      } else if (!updatedTeamMembers) {
        // Case: Duplicated email user
        toast(
          triggerLaunchdeckToast({
            useCase: "show-error-state",
            label: "Unfortunately something went wrong. Please try again later.",
            isMobileView
          })
        )

        // setUpdatedTeamStatus(updatedTeamMembers)
      }

      resetEditDsrTeamMembers()
      resetForm()
    }

  }, [editDsrTeamMembersOutcome, resetEditDsrTeamMembers]);

  useEffect(() => {
    if (checkIfExistingUserOutcome) {
      const { nextActionPath, userCardData } = checkIfExistingUserOutcome || {};

      setMemberCardLocalState(prevState => ({
        ...prevState,
        nextActionPath,
        ...userCardData && { userCardData }
      }))

      if (userCardData?.memberIdToken) {
        setDetectedExistingUserIdToken(userCardData.memberIdToken)
      }

      if (nextActionPath === "show-cannot-add-user-card") {

        toast(
          triggerLaunchdeckToast({
            useCase: "show-error-state",
            duration: "9000",
            bannerText: "User cannot be added to this Room",
            label: "This user has been deactivated or has left their organization",
            isMobileView
          })
        )

        resetForm()

      } else {
   
        if (nextActionPath === "show-user-card") {
          setShowMemberCard(true)
        }
        if (nextActionPath === "show-new-user-preview") {
          setShowMemberCard(true)
          setShowCustomiseInviteSection(true)
        } else if (nextActionPath === "show-user-is-already-member") {
          setIsDuplicateUser(true)
        }

        setbuttonType('start-invite')
      }
      setIsSearchingForUser(false)
      resetCheckIfExistingUser()
    }
  }, [checkIfExistingUserOutcome, resetCheckIfExistingUser, memberCardLocalState])

  
  const renderMemberCard = () => {
    if (showMemberCard) {
      const { userCardData } = memberCardLocalState || {};
      const { memberFirstName, memberLastName, memberEmail, memberProfilePicSrc, memberOrgName, memberOrgTitle } = userCardData || {};
      const credentials = (memberOrgName && memberOrgTitle) ? memberOrgTitle + ', ' + memberOrgName : memberOrgName ? memberOrgName : memberEmail ? memberEmail : emailInput;
      const memberFullName = (memberFirstName && memberLastName) ? (memberFirstName + ' ' + memberLastName).trim() : memberFirstName ? memberFirstName.trim() : memberLastName ? memberLastName.trim() : "";
      return (
        <Flex className='flip-in-hor-bottom' justify="flex-start" align='center' bg='white' rounded='0.25em' border='1px solid' borderColor='gray.300' p='1em' minW='16em' w={isMobileView && '100%'}>
          {memberProfilePicSrc ?
            <Avatar width='3.8em' height='3.8em' bg='gray.100' color='gray.700' src={memberProfilePicSrc} />
            :
            <Box as={IoPersonCircleOutline} boxSize="2.5em" color="brandDark.500" />
          }
          <Flex direction='column' gap='0.25em' ml='1em' align='flex-start'>
            <Box fontSize='0.875em' lineHeight='1.375em' fontWeight='500' color='brandDark.500' textAlign='left'>{memberFullName && memberFullName}</Box>
            <Box fontSize='0.75em' lineHeight='1em' fontWeight='400' color='gray.500' textAlign='left'>{credentials}</Box>
          </Flex>
        </Flex>
      )
    } else return null;
  }


  const resetForm = () => {
    const isGuestMember = dsrUserTeam === 'audience' ? true : false

    setEmailInput("")
    setTeamInput(isGuestMember ? "buyer-team" : "")
    setTeamNameInputDisplay("")
    setChosenRole(isGuestMember ? "Member" : "")
    setFirstNameInput("")
    setLastNameInput("")
    setCompanyNameInput("")
    setTitleInput("")
    setbuttonType("proceed")
    setShowMemberCard(false)
    setMemberCardLocalState({ nextActionPath: "" })
    setShowCustomiseInviteSection(false)
    setIsDuplicateUser(false)
    // setUpdatedTeamStatus(null)
    setIsSearchingForUser(false)
    setShowNoTeamRoleError(false)
  }

  const onChangeHandler = event => {
    setShowNotValidEmailError(null)
    setShowIncompleteFormError(null)

    switch (event.target.name) {
      case ('email'): {
        setEmailInput(event.target.value)
        setAllInputsValidated(false)
        break;
      }
      case ('invitee-first-name'): {
        const firstNameInput = event.target.value
        setFirstNameInput(firstNameInput)
        setMemberCardLocalState({
          ...memberCardLocalState,
          userCardData: {
            ...memberCardLocalState.userCardData,
            memberFirstName: firstNameInput
          }
        })
        break;
      }
      case ('invitee-last-name'): {
        const lastNameInput = event.target.value
        setLastNameInput(lastNameInput)
        setMemberCardLocalState({
          ...memberCardLocalState,
          userCardData: {
            ...memberCardLocalState.userCardData,
            memberLastName: lastNameInput
          }
        })
        break;
      }
      case ('company-name'): {
        const companyNameInput = event.target.value
        setCompanyNameInput(companyNameInput)
        setMemberCardLocalState({
          ...memberCardLocalState,
          userCardData: {
            ...memberCardLocalState.userCardData,
            memberOrgName: companyNameInput
          }
        })
        break;
      }
      case ('company-title'): {
        const companyTitleInput = event.target.value
        setTitleInput(companyTitleInput)
        setMemberCardLocalState({
          ...memberCardLocalState,
          userCardData: {
            ...memberCardLocalState.userCardData,
            memberOrgTitle: companyTitleInput
          }
        })
        break;
      }
      default: {
        break;
      }
    }
  };

  const handleAddMemberButton = () => {
    const trimmedEmail = emailInput.trim()
    const isValidEmail = validateEmail(trimmedEmail);

    if (allInputsValidated === true && isValidEmail === true) {
      const updateParams = {
        teamToUpdate: teamInput,
        updateAction: 'add-member',
        inviteeEmail: trimmedEmail,
        chosenRole: chosenRole || 'Member', // defaults to Member (no input required for Guests adding other guests) 
        firstName: firstNameInput?.trim(),
        lastName: lastNameInput?.trim(),
        inviteeCompanyName: companyNameInput?.trim(),
        inviteeCompanyTitle: titleInput?.trim(),
        userId: detectedExistingUserIdToken,
        inviterUserId: getThisUserIdToken()
      }
      
      setShowNotValidEmailError(false)
      handleEditDsrMembers(updateParams);
    } else if (!isValidEmail) {
      setShowNotValidEmailError(true)
      setIsSearchingForUser(false)
    }

  }

  // UX: Pick Team
  const handlePickTeamOption = (teamToUpdate) => {
    setTeamInput(teamToUpdate);
    !!showNoTeamRoleError && setShowNoTeamRoleError(false)

    if (teamToUpdate === 'buyer-team') {
      setTeamNameInputDisplay("Guests")
      setChosenRole("")
      setShowPickRoleDropdown(false)
    } else if (teamToUpdate === 'seller-team') {
      setTeamNameInputDisplay("Hosts")
    }

    setShowIncompleteFormError(false);
  }

  const handlePickRoleOption = (pickedRole) => {
    setChosenRole(pickedRole)
    !!showNoTeamRoleError && setShowNoTeamRoleError(false)
  }

  const handleClickProceedButton = () => {
    setShowNotValidEmailError(false)
    setIsSearchingForUser(true)

    const trimmedEmail = emailInput.trim()
    const isValidEmail = validateEmail(trimmedEmail);
    let allowProceed = true;

    if (!teamInput || (teamInput === "seller-team" && !chosenRole)) { 
      setShowNoTeamRoleError(true)
      allowProceed = false
    }

    if (!isValidEmail) {
      setShowNotValidEmailError(true)
      setIsSearchingForUser(false)
      allowProceed = false
    }

    if (allowProceed) checkIfExistingUser(trimmedEmail, dsrId)
  }

  const displayDuplicateMemberDetected = () => {
    const handleButtonClick = () => {
      handleCloseModal()
      // setUpdatedTeamStatus("")
      resetEditDsrTeamMembers()
    }

    return (
      <Box mb='1em' px='1em' w='100%'>
        <Box fontSize='0.875em'><span style={{ fontStyle: 'italic' }}>{emailInput}</span> is already a member of this Room. You won't have to do anything else!</Box>
        <Flex w='100%' justify={['center', 'flex-start']} mt='1.5em'>
          <LaunchdeckButton bg='brand.500' fontSize='0.8em' py='0.4em' color='white' onClick={() => handleButtonClick()} label='OK' />
        </Flex>
      </Box>
    )
  }

  const handleEditDsrMembers = async (updateParams) => {

    const updateTeamParams = { dsrId, updateParams }
    await editDsrTeamMembers(updateTeamParams);
  }

  const renderTempAdditionalInfo = () => {

    return (
      <Flex bg='gray.50' direction='column' rounded='0.25em' w='100%' mb='1em' p='1em' mt='1.5em'>

        <Flex justify='flex-start' align='center' fontSize='0.875em' lineHeight='1.25em' gap='0.75em'>
          <BsPersonVcard />
          <Box color='brandDark.500' fontWeight='600'> Customise your invite</Box>
          <LaunchdeckTag bg='none' color='brand.500' label='(Optional)' fontSize='0.8em' />
        </Flex>
        <Box my='1em' w='100%'>
          {/* // Company Name & Designation */}
          <Flex justify='space-between' align='flex-start'>
            <Box w='100%' pr='1em'>
              <LaunchdeckFormInput
                onChange={onChangeHandler}
                name={'invitee-first-name'}
                label="First Name"
              />
            </Box>

            <Box w='100%'>
              <LaunchdeckFormInput
                onChange={onChangeHandler}
                name={'invitee-last-name'}
                label="Last Name"
              />

            </Box>
          </Flex>
          {/* // Company Name & Designation */}
          <Flex justify='space-between' align='flex-start' mt='1em'>
            <Box w='100%' pr='1em'>
              <LaunchdeckFormInput
                onChange={onChangeHandler}
                name={'company-name'}
                label="Company"
              />
            </Box>

            <Box w='100%'>
              <LaunchdeckFormInput
                onChange={onChangeHandler}
                name={'company-title'}
                label="Company Role"
              />

            </Box>
          </Flex>
        </Box>
      </Flex>
    )
  }

  const renderCtaButton = () => {
    switch (buttonType) {
      case ('proceed'): {
        return (
          <LaunchdeckButton bg={allInputsValidated ? 'brand.500' : 'gray.300'} w='100%' color='white' cursor={isSearchingForUser ? "default" : "pointer"} onClick={() => handleClickProceedButton()} label='Search' />
        )
      }
      case ('start-invite'): {
        return (
          <Flex gap='1em'>
            <LaunchdeckButton noHover bg='gray.200' color='brandDark.500'  w='100%'  onClick={() => resetForm()} label='Cancel' />
            <LaunchdeckButton bg='brand.500' color='white'  w='100%'  onClick={() => allInputsValidated && handleAddMemberButton()} label='Send invite' />
          </Flex>
        )
      }
      default: {
        return null;
      }
    }
  }

  if (editingTeamInProgress) {
    return <PageLoader />
  } else {
    return (
      <Flex direction='column' justify={['flex-start', 'flex-start', 'center', 'center']} align='center' mt='2em' mb='1em' p='1em' border='1px dotted #E5EAEF' rounded='0.5em' bg='gray.50' w='100%' h={['auto', 'auto', '100%', '100%']}>
        <Flex justify={['center','flex-start']} w='100%' fontSize='0.875em' color='brandDark.500' mb={['0em', '1em']} fontWeight='600' px={['1em']}>{isNoOrgUser ? 'Invite others to this Room' : 'Invite an external member'} </Flex>
        {isDuplicateUser ? displayDuplicateMemberDetected() :
          <React.Fragment>
            <Box w='100%' p={["1.5em 0", "1.5em 1em"]} align='center' gap='1em'>
              {
                showMemberCard ?
                  <Grid templateColumns={["1fr", "1fr 1fr"]} templateRows={["1fr 1fr", "1fr"]} gap='1em' align='center'>
                    {renderMemberCard()}
                    <Flex gap='1em' className='fade-in'>
                      <Flex direction='column' flex="1" justify='center' align='center' 
                      bg='white'
                      rounded='0.25em' border='1px solid' borderColor='gray.300'
                      >
                        <Box fontSize='0.7em' color='brand.500' fontWeight='600'>TEAM</Box>
                        <Box fontSize='0.8em'>{teamNameInputDisplay || "Guest"}</Box>
                      </Flex>
                      <Flex direction='column' flex="1" justify='center' align='center'
                          bg='white'
                          rounded='0.25em' border='1px solid' borderColor='gray.300'
                          >
                        <Box fontSize='0.7em' color='brandPink.500' fontWeight='600'>ROLE</Box>
                        <Box fontSize='0.8em'>{chosenRole || "Member"}</Box>
                      </Flex>
                    </Flex>
                  </Grid>
                  :
                  <>
                    <Box className="invite-form-input-container__email-input-container">
                      <LaunchdeckFormInput
                        label='Email'
                        name={'email'}
                        onChange={onChangeHandler}
                        value={emailInput}
                        placeholder={'e.g. my@email.com'}
                        isRequired={true}
                        // isDisabled={contactLaunchdeckInProgress}

                        errorLogic={showNotValidEmailError}
                        errorMessage={'Invalid email format'}
                      />

                    </Box>

                    <Flex direction='column' w='100%' mt='1em' gap='1em' className='fade-in'>
                      <Flex direction={['column', 'row']} gap='1em'>
                        {(dsrUserTeam === 'host') &&
                          <Box className="invite-form-input-container__team-input-container" flex='1'>
                            <Box w='100%' position='relative'>
                              <Box bg='whiteAlpha.500' fontWeight='600' fontSize='0.7em' position='absolute' bottom='3em' left='1em' zIndex='2'> Team </Box>
                              <Flex className='user-invite-dropdown-menu' onClick={() => setShowPickTeamDropdown(!showPickTeamDropdown)} ref={teamPickerDropdownRef}>
                                {teamNameInputDisplay ? <Box color='brandDark.500' fontSize='0.875em'>{teamNameInputDisplay}</Box> : <Box color="gray.300" fontSize='0.875em'>Pick Team</Box>}
                                <Box as={GoChevronDown} boxSize="0.75em" color="gray.500" />
                                <Box className='user-invite-dropdown-menu__dropdown' display={(showPickTeamDropdown) ? 'inline-block' : 'none'}>
                                  <Box className='user-invite-dropdown-menu__dropdown-option-display' onClick={() => handlePickTeamOption('seller-team')}>{"Hosts"}</Box>
                                  <Box className='user-invite-dropdown-menu__dropdown-option-display' onClick={() => handlePickTeamOption('buyer-team')}>{"Guests"}</Box>
                                </Box>
                              </Flex>
                            </Box>
                          </Box>
                        }

                        {
                          (teamInput === 'seller-team') &&
                          <Box className="invite-form-input-container__team-input-container fade-in" flex='1' zIndex="200">
                            <Box w='100%' position='relative'>
                              <Box bg='whiteAlpha.500' fontWeight='600' fontSize='0.7em' position='absolute' bottom='3em' left='1em' zIndex='2'> Role </Box>
                              <Flex className='user-invite-dropdown-menu' onClick={() => {
                                setShowNoTeamRoleError(false)
                                setShowPickRoleDropdown(!showPickRoleDropdown)
                              }} ref={rolePickerDropdownRef}>
                                {chosenRole ? <Box color='brandDark.500' fontSize='0.875em'>{chosenRole}</Box> : <Box color="gray.300" fontSize='0.875em'>Choose Role</Box>}
                                <Box as={GoChevronDown} boxSize="0.75em" color="gray.500" />
                                <Box className='user-invite-dropdown-menu__dropdown' display={(showPickRoleDropdown) ? 'inline-block' : 'none'}>
                                  <Box className='user-invite-dropdown-menu__dropdown-option-display' onClick={() => handlePickRoleOption('Member')}>{"Member"}</Box>
                                  {isDsrAdmin && <Box className='user-invite-dropdown-menu__dropdown-option-display' onClick={() => handlePickRoleOption('Admin')}>{"Admin"}</Box>}
                                </Box>
                              </Flex>
                            </Box>
                          </Box>
                        }
                      </Flex>
                      <Box mt='-0.5em' textAlign='left'>
                        <WarningTextMessage fontSize='0.7em' errorLogic={showNoTeamRoleError} message='Please decide whether they should be in the host or guest team & their role here' />
                      </Box>

                      {!showCustomiseInviteSection && displayUserTeamRolePermissions({ dsrUserTeam, teamInput, chosenRole, isMobileView })}
                    </Flex>
                  </>
              }
            </Box>

            <Flex w='100%' height='auto'>
              {showCustomiseInviteSection && renderTempAdditionalInfo()}

              {/* // Change text to say the invite will be sent when the Room is published if NOT seller-lead */}
              {showIncompleteFormError && <Text textAlign='center' color='brandPink.500' fontSize='0.8em'>Please provide a valid Email, Team, and Role to proceed</Text>}
            </Flex>

            <Flex w='100%'  justify={["center","flex-end"]} mt={['0em','2em']} pb={['1em','0em']} px={["0",'1em']}>
              <Flex justify='flex-end' >
              {renderCtaButton()}
              </Flex>
            </Flex>
          </React.Fragment>
        }

      </Flex>
    )
  }
}


function mapStateToProps(state) {
  return {
    isDsrAdmin: state.dsrAdmin.isDsrAdmin,
    editDsrTeamMembersOutcome: state.editDsrTeamMembersOutcome.results.data,
    editingTeamInProgress: state.editDsrTeamMembersOutcome.isLoading,
    dsrUserTeam: state.dsrUserTeam.userTeam,
    checkIfExistingUserOutcome: state.checkIfExistingUserOutcome.results.data,
    isMobileView: state.mobileViewMode.isMobileView
  };
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      editDsrTeamMembers,
      resetEditDsrTeamMembers,
      checkIfExistingUser,
      resetCheckIfExistingUser,
    },
    dispatch,
  )


export default withRouter(connect(mapStateToProps, mapDispatchToProps)(DsrAddTeamMemberForm));
